import API_URL from '@/config/api';
import { formatApiError } from '@/utils/apiError';

export const BRAND = {
  probound: { label: 'ProBound', colour: '#2F5E96', ink: '#fff' },
  prodecor: { label: 'ProDecor', colour: '#D5AB09', ink: '#2B2101' },
  proepoxy: { label: 'ProEpoxy', colour: '#7A0B7A', ink: '#fff' },
  material_order: { label: 'Material Order', colour: '#1f4030', ink: '#fff' },
  manual: { label: 'Manual · stock out', colour: '#b45309', ink: '#fff' },
};

export const OUT_CATEGORIES = [
  { value: 'complete_order', label: 'Complete order' },
  { value: 'partial_order', label: 'Partial order' },
  { value: 'training', label: 'Training' },
  { value: 'promotion', label: 'Promotion' },
];

export const PAYMENT_METHODS = [
  { value: 'bank_transfer', label: 'Bank transfer' },
  { value: 'epos', label: 'EPOS' },
  { value: 'stripe', label: 'Stripe' },
  { value: 'worldpay', label: 'WorldPay' },
  { value: 'cash', label: 'Cash' },
];

export const PRIORITY = {
  urgent: { label: 'Urgent', cls: 'bg-rose-600 text-white' },
  soon: { label: 'Soon', cls: 'bg-amber-400 text-amber-950' },
  no_rush: { label: 'No rush', cls: 'bg-slate-200 text-slate-700' },
};

export async function packApi(method, path, body) {
  const r = await fetch(`${API_URL}/api/staff/packing${path}`, { method, credentials: 'include', headers: body ? { 'Content-Type': 'application/json' } : undefined, body: body ? JSON.stringify(body) : undefined });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(formatApiError(d) || 'Request failed');
  return d;
}

export const fmtWhen = (iso) => (iso ? new Date(iso).toLocaleString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }) : '');
export const fmtGBP = (n) => new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 2 }).format(n || 0);

export const openPackingSlip = (order) => window.open(`${API_URL}/api/staff/packing/${order.product}/${order.id}/slip?print=1`, '_blank', 'noopener');
